'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Parse url
 * @param   {Object} urls URLs map to use
 * @param   {String} name URL name to parse
 * @param   {Object} opts Parameters for the URL
 * @returns {String}      Parsed URL
 */
function parser(urls, name) {
  let opts = arguments.length <= 2 || arguments[2] === undefined ? undefined : arguments[2];

  const url = urls[name];

  if (!opts) return url;

  return url.split('/').map(function (key) {
    if (key[0] !== ':') return key;
    return opts[key.slice(1, key.length)];
  }).join('/');
}

exports.default = parser;